var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card no-border"},[(_vm.item.image)?_c('div',{staticClass:"card-image"},[_c('img',{attrs:{"src":_vm.item.image}})]):_vm._e(),_c('div',{staticClass:"card-section"},[_c('h3',[_vm._v(_vm._s(_vm.item.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }